import React from 'react';
import { Button, Col, Container, Form, Image, InputGroup } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { LoaderComponente } from "../../Components/LoaderComponente";
import "../../Estilo/ResetForgottenPassword.css";
import logo from "../../Imagens/logo-login.png";
import salvar from '../../Imagens/save-16.png';
import { RequestPasswordResetViewModel } from './RequestPasswordResetViewModel';

interface MyProps {
    navigation: any;
    delegate: RequestPasswordResetViewControllerDelegate;
    viewModel: RequestPasswordResetViewModel;
    token: string;
}

export interface RequestPasswordResetViewControllerDelegate {
    tapDimiss(navigation: any): void;
}

export class RequestPasswordResetViewController extends React.Component<MyProps> {
    state = {
        isLoading: false,
        email: ''
    }

    render() {
        return (
            <div className="reset-password-page">
                <Container fluid="md" className="reset-password-container">
                    <Col lg={12}>
                        <Image
                            src={logo}
                            height={200}
                            width={500}
                            className="center"
                            fluid
                        />
                    </Col>
                    <h4 className='mb-4 mt-2 text-center'>Solicitar Redefinição de Senha</h4>
                    <Form>
                        <Form.Group className="mb-3" controlId="senha">
                            <Form.Label className="isRequired">Email</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    placeholder="Informe o email cadastrado"
                                    value={this.state.email}
                                    onChange={(e) => this.setState({ email: e.target.value })}
                                />
                            </InputGroup>
                        </Form.Group>

                        <Button
                            className="w-100 fw-bold d-flex justify-content-center align-items-center"
                            type="button"
                            onClick={() => this.save()}
                            variant="primary"
                        >
                            <Image className="mr-3" src={salvar} />
                            Enviar
                        </Button>
                    </Form>

                    <ToastContainer />
                    <LoaderComponente
                        show={this.state.isLoading}
                        hide={() => this.setState({ isLoading: false })}
                    />
                </Container>
            </div>
        );
    }

    private save() {
        const { email } = this.state;

        if (!email) {
            this.showFieldsEmpty("Preencha todos os campos obrigatórios!");
            return;
        }

        this.setState({ isLoading: true });


        this.props.viewModel.fetchSave({ email }).then((response) => {
            toast.success("Email enviado", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            setTimeout(() => {
                const parts = window.location.pathname.split("/").filter(Boolean);
                const prefix = parts[0];
                window.location.href = `/${prefix}/login`;
            }, 1000);

        }).catch((e) => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }).finally(() => {
            this.setState({ isLoading: false });
        });

    }

    private showFieldsEmpty(message: string) {
        toast.error(message, {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    }
}
